module.exports = __webpack_public_path__ + "img/marketing-pulse.32d206ba.png";